import { IProductMission } from "../interfaces/product-mission.interface";

export class ProductMission implements IProductMission {
  productmissionLoadedExpectedMassTotal: number;
  productName: string;
  productfamilyname: string;

  constructor(missionProduct: IProductMission) {
    Object.keys(missionProduct).map(key => this[key] = missionProduct[key]);
  }
}